import { render, staticRenderFns } from "./NsHeaderAem.vue?vue&type=template&id=1b8ca54a&scoped=true&"
import script from "./NsHeaderAem.vue?vue&type=script&lang=js&"
export * from "./NsHeaderAem.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderAem.vue?vue&type=style&index=0&id=1b8ca54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ca54a",
  null
  
)

export default component.exports